module.exports = __webpack_public_path__ + "static/media/close-white-icon.521d195a.svg";